import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import services from 'core/services';
import { PureComponent, Page } from 'core/components';
import { Link, Icon, List, ListInput, Button, Col, Card, CardContent, SwiperSlide, Swiper } from 'core/components/Framework7';
import { withLocale } from 'core/decorators';
import { ProductList, Filter, NodeTitleSwiper } from 'content/components';
import { changeVisibleSearchView } from 'core/module/operations';

import translations from './i18n';
import classes from './styles.module.css';

const hasCordova = process.env.TARGET;

class SearchPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      nodes: [],
      nodeId: null,
      filter: null,
      sort: null,
      parent: props.parent,
      brands: [],
      availability: this.initialValue.checkAvailability,
      offset: 0,
      limit: 10,
      hasNext: true,
      loadingMore: false,
      initialLoad: false,
      params: null,
      searchText: '',
      search: null,
      empty: false,
    };

    this.props.translator.addModuleResource('search', translations);
  };

  static get defaultProps() {
    return {
      items: [],
      swiper: {
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 8,
        // navigation: false,
        freeMode: true,
      },
      navigation: true,
    }
  }

  get initialValue() {
    const { env } = this.props;

    return {
      checkAvailability: env ? env.checkAvailability : null,
    }
  }

  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  loadingMore(loading = false) {
    this.setState((prevState, props) => {
      return { loadingMore: loading }
    });
  };

  loadMore() {
    this.loadingMore(true);
    this.getResultSearch()
  }

  onScroll(params) {

  }

  onSubmit(e) {
    e.preventDefault();
  }

  get parentProducts() {
    const items = this.state.nodes;

    if (!items || items.length == 0) return

    return items.map(item => {
      return {
        id: item.id,
        alt: item.category ? item.category.cover ? item.category.cover.title : null : null,
        url: item.category ? item.category.cover ? item.category.cover.url : null : null,
        title: item.category ? item.category.title : null,
        link: item.id,
        childrenType: item.childrenType,
      }
    })
  }

  handleNodeTitleClicked(nodeId = null) {
    this.createRequest(
      this.state.search,
      this.state.filter,
      this.state.sort,
      this.state.availability,
      nodeId, true)
  }

  handleSearchText(e) {
    this.setState({
      searchText: e.target.value
    })
  }

  handleBarcodeScanner() {
    if (!this.$device.cordova || hasCordova === "web") return

    cordova.plugins.barcodeScanner.scan(result => {
      this.setState({
        searchText: result.text
      }, () => {
        this.changeSearchText(result.text)
      })
    }, error => {
      console.log("Scanning failed:", error)
    })
  }

  handleSearchClick() {
    this.setState((state, props) => ({
      search: this.state.searchText,
      nodeId: null,
      sort: null,
      filter: null,
    }), () => {
      this.changeSearchText(this.state.search)
    }
    )
  }

  changeSearchText(value) {
    this.createRequest(value, null, null, this.state.availability, null, true)
  }

  changeSort(value, key = "order_by") {
    this.createRequest(this.state.search, this.state.filter, value, this.state.availability, this.state.nodeId)
  }

  changeFilter(value, key = "brand") {
    this.createRequest(this.state.search, value, this.state.sort, this.state.availability, this.state.nodeId)
  }

  changeAvailability(value) {
    this.createRequest(this.state.search, this.state.filter, this.state.sort, value, this.state.nodeId)
  }

  createRequest(search, filter, sort, availability = true, nodeId = null, getBrands = false) {
    this.setState({
      offset: 0,
      limit: 10,
      hasNext: true,
      sort: sort,
      filter: filter,
      availability: availability,

      items: [],
      search: search,
      nodeId: nodeId,

      initialLoad: true,
      empty: false
    }, () => {
      if (getBrands) {
        this.getNodeBrands();
      }

      this.getResultSearch();
    })
  }

  getResultSearch() {
    const { hasNext, limit, offset, availability, sort, filter, nodeId: nodeId, search } = this.state;

    if (!hasNext || !search || search === "" || search.length < 1) {
      this.loading(false);
      this.loadingMore(false);
      this.setState({
        initialLoad: false
      })
      return
    }

    let searchButton = document.getElementById("submitBtn");
    if (searchButton) {
      searchButton.focus();
    }

    this.setState({
      empty: false
    })

    this.loading(true);
    this.loadingMore(true);

    let searchParams = {
      store: 2,
      limit,
      offset,
      check_availability: availability,
      search: search,
    }

    if (sort) {
      searchParams.order_by = sort
    }

    if (filter) {
      searchParams.brand = filter
    }

    if (nodeId) {
      searchParams.node_id = nodeId
    }

    services.ecommerce.Product.getResultSearch(searchParams)
      .then(r => {
        this.setState((prevState, props) => {
          const productNodes = this.state.items.length > 0 ? [...this.state.items, ...r.data.products] : r.data.products;

          return {
            items: productNodes,
            limit: r.meta ? r.meta.limit : null,
            offset: r.meta ? r.meta.offset + r.meta.limit : null,
            hasNext: r.meta ? r.meta.next === "has next" ? (r.data && r.data.products && r.data.products.length > 0) : false : false,
            nodes: r.data && r.data.nodes && r.data.nodes.length > 0 && !searchParams.node_id ? r.data.nodes : (searchParams.offset > 0 || searchParams.node_id ? prevState.nodes : null),
          }
        })
      })
      .catch(e => {
        this.setState({
          hasNext: false
        })
        return this.$f7.dialog.alert('خطا در برقراری ارتباط با سیستم', 'خطا')
      })
      .finally(r => {
        this.loading(false);
        this.loadingMore(false);
        this.setState({
          initialLoad: false
        })

        if (this.state.items.length === 0) {
          this.setState({
            empty: true
          })
        }
      })
  }

  getNodeBrands() {
    const nodeId = this.state.nodeId || "main_categories"

    const params = {
      store: 2,
      search: this.state.searchText,
    }

    services.ecommerce.Node.getNodeBrands(nodeId, params)
      .then(r => {
        this.setState({
          brands: r.data.brands
        })
      })
      .catch(e => {

      })
      .finally(r => {
        this.loading(false)
      })
  }

  renderEmpty() {
    return (
      <Col width="100" className={classes.empty}>
        <Icon icon="mdi-basket" />
        <div className={'product-list-empty'}>{'مشتری گرامی'}<br />{'با تشکر از همراهی و صبوری شما، کالاهای این دسته به زودی معرفی می گردد.'}</div>
      </Col>
    )
  }

  render() {
    const { items, nodes, nodeId, filter, sort, brands, hasNext, loadingMore, initialLoad, empty, searchText } = this.state
    const { navigate } = this.props

    return (
      <Page pageName="search"
        closePopup={true}
        showClose={true}
        showBack={false}
        closePopupClassName={'#popup-search-view'}
      // navigate={navigate}
      // onCloseNavClicked={() => this.props.changeVisibleSearchView(false)}
      // onCloseNavClicked={() => this.$f7.$('#view-search').removeClass('modal-in')}
      >
        <div className={classes.main}>
          <form action="" onSubmit={this.onSubmit} className={`${classes.searchBar} button-top-full-width`}>
            <List noHairlinesMd className={classes.list}>
              <ListInput
                id="searchinput"
                type="text"
                placeholder="جستجوی کالا با نام، بارکد، برند و یا ترکیبی از آنها"
                clearButton
                value={searchText}
                onInputClear={() => this.setState({ searchText: '' })}
                onChange={this.handleSearchText}
              >
              </ListInput>
            </List>
            <Button
              type="submit"
              iconOnly
              icon="mdi-magnify"
              className={classes.iconButton}
              onClick={this.handleSearchClick}
            />
            {this.$device.cordova &&
              <Button
                type="button"
                iconOnly
                icon="mdi-barcode-scan"
                id="submitBtn"
                className={classes.iconButton}
                onClick={this.handleBarcodeScanner}
              />
            }
          </form>

          <Filter
            filter={filter}
            sort={sort}
            brands={brands}
            onAvailabilityChange={this.changeAvailability}
            onSortChange={this.changeSort}
            onFilterChange={this.changeFilter}
          />

          {nodes && nodes.length > 0 &&
            <NodeTitleSwiper
              items={nodes}
              nodeId={nodeId}
              navigation={true}
              onNodeClicked={this.handleNodeTitleClicked}
            />
          }

          {!empty ? <ProductList
            items={items}
            hasNext={hasNext}
            loadMore={this.loadMore}
            loading={loadingMore}
            initialLoad={initialLoad}
            onScroll={this.onScroll}
            className={classes.infinite}
            navigate={navigate}
          /> : this.renderEmpty()}
        </div>
      </Page>
    );
  };
};

export default connect(
  state => ({
    cart: state.Cart.cart,
    env: state.General.env,
  }),
  {
    changeVisibleSearchView,
  }
)(withLocale('search')(autobind(SearchPage)));
